import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { isDefaultGuid, isNotNullOrEmpty } from "utils";

/*
  summary: simple generic component that uses fetch() for lookup by id effect on load
  returns: attribute is set to name by default, specify attribute for other attributes
*/
const GenericLookup = ({
	id,
	resource,
	attribute = "name",
	isHealthSafety,
}) => {
	const resourceList = useSelector((state) =>
		isHealthSafety
			? state.healthSafety[resource].results
			: state[resource].pagination
				? state[resource].pagination?.results
				: state[resource].data
	);

	// Handle null/undefined/empty id: return "-" early
	// Explicitly check for null to match PropTypes that allows null
	if (id === null || id === undefined || !resource || !resourceList) {
		return "-";
	}

	// Check for default/empty GUID
	if (isDefaultGuid(id)) {
		return "-";
	}

	// Perform lookup with non-null id
	const data =
		isNotNullOrEmpty(resourceList) &&
		resourceList.filter((r) => r.id === id)[0];

	return <>{data ? (data[attribute] || "-") : "-"}</>;
};

GenericLookup.propTypes = {
	id: (props, propName) => {
		const value = props[propName];
		if (value === null || value === undefined || typeof value === 'string') {
			return null;
		}
		return new Error(`Invalid prop \`${propName}\`: must be string or null`);
	},
	resource: PropTypes.string.isRequired,
	attribute: PropTypes.string,
	isHealthSafety: PropTypes.bool,
};

export default GenericLookup;
